module.exports = __webpack_public_path__ + "static/media/api-programming.3907c4e7.svg";